import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function(){
	let isMobile = false

	if ( window.innerWidth < 827 ) {
		isMobile = true;
	}

	/* News archive horizontal scrolling */
	function archiveHorizontalScroll(){
		let sections = gsap.utils.toArray( '.panel' );
		
		let maxWidth = 0;

		const getMaxWidth = () => {
			maxWidth = 0;
			sections.forEach((section) => {
				maxWidth += section.offsetWidth;
			});
		};
		getMaxWidth();
		ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

		if ( sections.length > 0 ){
			gsap.to(sections, {
				x: () => `-${maxWidth - window.innerWidth}`,
				ease: "none",
				scrollTrigger: {
					trigger: ".panels-container",
					pin: true,
					scrub: 0.8,
					invalidateOnRefresh: true,
					end: () => `+=${maxWidth}`,
					//markers: true,
				},
			});
		}
	}

	/* Filter search funcionality */
	function searchFuncionality(){
		const panelsContainer = document.querySelector( '.panels-container' )
		const searchFilters = document.querySelector( '.filters--news' )
		const searchButton = document.querySelector( '.filters--news .sf-field-search input' )
	
		if ( searchButton ){
			searchButton.addEventListener( 'click', function(e){
				var rect = e.target.getBoundingClientRect();
				var x = e.clientX - rect.left; //x position within the element.
				var y = e.clientY - rect.top;  //y position within the element.
				//console.log("Left? : " + x + " ; Top? : " + y + ".");

				if ( ! searchButton.classList.contains('open') ){
					searchButton.classList.toggle('open')
					gsap.fromTo( searchButton, { width: '72px' }, { width: '282px', ease: 'power2.inOut', duration: 0.5 } )
				} else if ( x > 200 ) {
					searchButton.classList.toggle('open')
					gsap.fromTo( searchButton, { width: '282px' }, { width: '72px', ease: 'power2.inOut', duration: 0.5 } )
				}
			} )
		}

		// Hide the filters when scrolled past the archive block
		// Determine if an element is in the visible viewport
		if ( panelsContainer ){
			function isInViewport(element) {
				var rect = element.getBoundingClientRect();
				var html = document.documentElement;
				return (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || html.clientHeight) &&
					rect.right <= (window.innerWidth || html.clientWidth)
				);
			}
			window.addEventListener('scroll', () => {
				if ( isInViewport( panelsContainer ) ){
					gsap.to( searchFilters, { x: 0, opacity: 1 } )
				} else {
					gsap.to( searchFilters, { x: 150, opacity: 0 } )
				}
			});
		}
	}

	function exploreButton(){
		const button = document.querySelector('.button--go')

		if ( button ) {
			button.addEventListener( 'click', function(e){
				e.preventDefault()
	
				window.scrollBy(0,150)
			} )
		}
	}
	
	if ( ! isMobile ) {
		archiveHorizontalScroll()
		searchFuncionality()
	}
	exploreButton()

	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
		//archiveHorizontalScroll()
		searchFuncionality()
	});
}